import { EnvironmentProviders, isDevMode, Provider } from '@angular/core';
import {
  TRANSLOCO_CONFIG,
  provideTransloco,
  provideTranslocoInterceptor,
  provideTranslocoMissingHandler,
  translocoConfig,
} from '@jsverse/transloco';

import { Config } from '@cbcore/services/config/config.service';
import { TranslationLoader } from '@cbcore/services/translation/translation-loader';
import { MyCustomMissingTranslationHandler } from '@cbcore/services/translation/missing-translation-handler.service';
import { CustomMergeInterceptor } from '@cbcore/services/translation/translation-interceptor';

export function provideTranslation(): Array<Provider | EnvironmentProviders> {
  return [
    ...provideTransloco({ config: {}, loader: TranslationLoader }),
    {
      provide: TRANSLOCO_CONFIG,
      useFactory: (config: Config) =>
        translocoConfig({
          availableLangs: config.CONFIG.supportedLanguages ?? ['en'],
          defaultLang: config.CONFIG.defaultLanguage ?? 'en',
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
          fallbackLang: config.CONFIG.fallbackLanguage ?? 'en',
          missingHandler: {
            useFallbackTranslation: true,
            logMissingKey: !isDevMode(),
          },
        }),
      deps: [Config],
    },
    // Must be after provideTransloco() to override DefaultMissingHandler/DefaultInterceptor.
    provideTranslocoMissingHandler(MyCustomMissingTranslationHandler),
    provideTranslocoInterceptor(CustomMergeInterceptor),
  ];
}
